import queryString from 'query-string'

const URL_RGE = /(http|https):\/\/([\w.]+\/?)\S*/

export const queryUrl = (url = window.location.href): Record<string, any> => {
  if (URL_RGE.test(url)) {
    return queryString.parseUrl(url).query
  } else {
    return queryString.parse(url)
  }
}
